import { render, staticRenderFns } from "./StudentNotesEdit.vue?vue&type=template&id=58b39ce8&scoped=true&"
import script from "./StudentNotesEdit.vue?vue&type=script&lang=js&"
export * from "./StudentNotesEdit.vue?vue&type=script&lang=js&"
import style0 from "./StudentNotesEdit.vue?vue&type=style&index=0&id=58b39ce8&scoped=true&lang=scss&"
import style1 from "./StudentNotesEdit.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b39ce8",
  null
  
)

export default component.exports